import React, { Component } from "react";
import { Col, Image, Row, Well } from "react-bootstrap";

import "./App.css";

function range(from, to) {
  return [...Array(to - from + 1).keys()].map(x => x + from);
}

function getPlateId(data) {
  return `${data.fileNames[0]}-${data.fileNames[1]}`;
}

function getIdList(data) {
  return range(data.fileNames[0], data.fileNames[1]);
}

function getImageFilePath(number) {
  return `${process.env.PUBLIC_URL}/img/DSC_${("0000" + number).slice(-4)}.JPG`;
}

function createFirstImage(number, plateId) {
  const path = getImageFilePath(number);

  return (
    <Col xs={12} md={10} mdOffset={1} key={path} className="Item-firstCol">
      <a href={path} data-lightbox={plateId}>
        <Image
          src={path}
          rounded
          responsive
          className="firstImage center-block"
        />
      </a>
    </Col>
  );
}

class Item extends Component {
  render() {
    const { data } = this.props;
    const plateId = getPlateId(data);
    const ids = getIdList(data);
    const firstImage = createFirstImage(ids.shift(), plateId);

    const thumbnailList = ids.map((number, index) => {
      const path = getImageFilePath(number);
      let xs = 6;
      let md = 3;
      return (
        <Col xs={xs} md={md} key={path} className="Item-col">
          <a href={path} data-lightbox={plateId}>
            <Image src={path} rounded className="thumbnail" />
          </a>
        </Col>
      );
    });

    return (
      <div>
        <Well>
          <h3>{plateId}</h3>
          <Row className="Item-row">{firstImage}</Row>
          <Row className="item-row">{thumbnailList}</Row>
        </Well>
      </div>
    );
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/Item.js